module.exports = __webpack_public_path__ + "banner1.7b31259ed6eb2cef35ec.png";